// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {

	// Select all anchor tags with href attributes starting with "#"
	const anchors = document.querySelectorAll('a[href^="#"]:not(.footnote-label):not(.search-icon a)');

	anchors.forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			// Prevent the default link click behavior
			e.preventDefault();

			// Get the target element
			let target = document.querySelector(this.getAttribute('href'));

			// Set the offset based on the screen width
			let offset = window.innerWidth < 992 ? 250 : 150;

			// If the target element is found
			if (target) {
				// Calculate the position of the element and adjust with the offset
				let targetPos = target.getBoundingClientRect().top + window.scrollY;

				// Scroll to the adjusted position with a smooth behavior
				window.scrollTo({
					top: targetPos - offset,
					behavior: 'smooth',
				});
			}
		});
	});

	//us map
	if (document.querySelector('#us-map')) {
		let pathsAndCircles = document.querySelectorAll('path, circle');
		pathsAndCircles.forEach(element => {
			element.addEventListener('mouseover', function (e) {
				let infoBox = document.querySelector('#info-box');
				infoBox.style.display = 'block';
				infoBox.innerHTML = this.getAttribute('data-info');
			});

			element.addEventListener('mouseout', function (e) {
				let infoBox = document.querySelector('#info-box');
				infoBox.style.display = 'none';
			});

			element.addEventListener('click', function () {
				let state = this.getAttribute('data-info');
				state = state.replace(/\s+/g, '-').toLowerCase();
				window.location.href = "/mesothelioma-lawyer/" + state;
			});
		});

		let ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (ios) {
			let links = document.querySelectorAll('a');
			links.forEach(link => {
				link.addEventListener('click', function (e) {
					e.preventDefault();
					let href = this.getAttribute('href');
					window.open(href, '_blank');
				});
			});
		}
	}

	initializeScrollSpy();
	let sidebarTitle = document.querySelector('#toc .sidebar-title');
	if (sidebarTitle) {
		const toc = document.querySelector('#table-of-contents');
		const currentToc = document.querySelector('#current-toc');

		sidebarTitle.addEventListener('click', function () {
			if (toc.style.maxHeight) {
				toc.style.maxHeight = null;
				toc.style.overflowY = "visible";
				currentToc.style.display = "block";
			} else {
				toc.style.maxHeight = toc.scrollHeight > 100 ? "100px" : toc.scrollHeight + "px";
				toc.style.overflowY = "auto";
				currentToc.style.display = "none";
			}
		});

		document.querySelectorAll('.single-content h2').forEach(function (h2) {
			if (!h2.id) {
				var text = h2.textContent || h2.innerText;
				h2.id = createSlug(text);
			}
		});

		let moveTOC = function () {
			const toc = document.getElementById('toc');
			const content = document.querySelector('.single-content');
			const contentParent = document.querySelector('.content-sidebar-wrapper');
			if (window.innerWidth < 992) {
				contentParent.insertBefore(toc, content);
			} else {
				const sidebar = document.querySelector('.sidebar .has-sticky');
				sidebar.insertBefore(toc, sidebar.firstChild);
			}
		}

		moveTOC();
		window.addEventListener('resize', moveTOC);

		// Add event listener to hide TOC and show current TOC on click of an li
		document.querySelectorAll('#table-of-contents li a').forEach(function (link) {
			link.addEventListener('click', function (event) {
				event.preventDefault(); // Prevent default link behavior
				toc.style.maxHeight = null;
				toc.style.overflowY = "visible";
				currentToc.style.display = "block";
				currentToc.textContent = link.textContent; // Update the current TOC text

				// Scroll to the target h2 element
				const targetId = link.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}

				// Update active class manually
				document.querySelectorAll('#table-of-contents li a').forEach(link => {
					link.classList.remove('active');
				});
				link.classList.add('active');
			});
		});
	}

	//source and footnotes
	const footnoteLabels = document.querySelectorAll('.footnote-label');

	if (footnoteLabels.length > 0) {
		footnoteLabels.forEach((footnoteLabel) => {
			let findSource = footnoteLabel.getAttribute('href');
			let sourceText = document.querySelector('.sources ' + findSource)?.innerHTML;

			if (sourceText) {
				footnoteLabel.dataset.bsToggle = "popover";
				footnoteLabel.dataset.bsPlacement = "top";
				footnoteLabel.dataset.bsHtml = "true";
				footnoteLabel.dataset.bsContent = sourceText;

				// Initialize the popover
				const popover = new bootstrap.Popover(footnoteLabel, {
					trigger: 'manual', // Switch to manual triggering
					animation: true,
					html: true, // Make sure HTML content is enabled
					content: sourceText
				});

				let isPopoverHovered = false;

				// Show the popover when the trigger element is hovered
				footnoteLabel.addEventListener('mouseenter', function () {
					popover.show();

					// Check if the popover content is hovered
					setTimeout(() => { // Timeout ensures the popover is in the DOM
						const popoverNode = document.querySelector('.popover');
						if (popoverNode) {
							popoverNode.addEventListener('mouseenter', () => isPopoverHovered = true);
							popoverNode.addEventListener('mouseleave', () => {
								isPopoverHovered = false;
								popover.hide(); // Hide the popover when mouse leaves the popover content
							});
						}
					}, 10);
				});

				// Hide the popover when the mouse leaves the trigger element and the popover content
				footnoteLabel.addEventListener('mouseleave', function () {
					setTimeout(() => {
						if (!isPopoverHovered) {
							popover.hide();
						}
					}, 10);
				});
			}
		});
	}

	// Get the source toggle and overlay elements
	let sourceToggle = document.querySelector('.source-toggle');
	let sourcesEl = document.querySelector('.sources .has__overlay');

	if (sourceToggle && sourcesEl) {
		sourceToggle.addEventListener('click', function (event) {
			event.preventDefault();
			if (sourcesEl.classList.contains('minimized')) {
				sourcesEl.classList.remove('minimized');
			} else {
				sourcesEl.classList.add('minimized');
			}
		});
	}

	//search bar toggle
	const searchIcon = document.querySelector('.search-icon');
	const searchBlock = document.querySelector('.search-block');

	if (searchIcon && searchBlock) {
		searchIcon.addEventListener("click", function (e) {
			e.preventDefault();

			// Toggle body class
			document.body.classList.toggle('has-search-active');

			// Slide toggle search block
			if (searchBlock.style.maxHeight) {
				searchBlock.style.maxHeight = null;
			} else {
				searchBlock.style.maxHeight = searchBlock.scrollHeight + "px";
			}

			// Try to find 'i' icon
			let icon = this.querySelector('i');

			if (icon) {
				// This will run if the FontAwesome JavaScript has not replaced the 'i' elements with SVGs (e.g., if JS is disabled)
				if (icon.classList.contains('fa-magnifying-glass')) {
					icon.classList.remove('fa-magnifying-glass');
					icon.classList.add('fa-close');
				} else {
					icon.classList.remove('fa-close');
					icon.classList.add('fa-magnifying-glass');
				}
			} else {
				// This will run if the 'i' elements have been replaced with SVGs
				let iconContainer = this.querySelector('.search-icon a');
				let isMagnifyingGlass = iconContainer.innerHTML.includes("fa-magnifying-glass");

				iconContainer.innerHTML = isMagnifyingGlass ? `<svg class="svg-inline--fa fa-close" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="close" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path></svg>` :
					`<svg class="svg-inline--fa fa-magnifying-glass" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="magnifying-glass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path></svg>`;
			}
		});
	}

	//off canvas menu items


	let offcanvasMainMenuSearch = function () {
		var menus = document.querySelectorAll('#main-nav .menu-item-has-children > a');

		var searchForm = document.querySelector('.search-block');
		var offcanvasMainNav = document.querySelector('#main-menu');

		if (window.innerWidth <= 1200) {
			menus.forEach(function (menu) {
				menu.addEventListener('click', function (e) {
					var parentMenu = this.parentNode;
					var subMenu = parentMenu.querySelector('.dropdown-menu');

					if (!parentMenu.classList.contains('menu-open')) {
						e.preventDefault();
						subMenu.style.display = (subMenu.style.display === 'none' || subMenu.style.display === '') ? 'block' : 'none';
						parentMenu.classList.add('menu-open');
					}
				});
			});

			if (searchForm && offcanvasMainNav) {
				offcanvasMainNav.insertAdjacentElement('afterend', searchForm);
			}

		} else {
			menus.forEach(function (menu) {
				var parentMenu = menu.parentNode;
				var subMenu = parentMenu.querySelector('.dropdown-menu');
				subMenu.style.display = '';
				parentMenu.classList.remove('menu-open');
			});

			if (searchForm) {
				var originalPosition = document.querySelector('#main-nav');
				if (originalPosition) {
					originalPosition.insertAdjacentElement('afterend', searchForm);
				}
			}
		}
	}

	offcanvasMainMenuSearch();
	window.addEventListener('resize', offcanvasMainMenuSearch);


});

function initializeScrollSpy() {
	const sections = document.querySelectorAll('.single-content h2');
	const currentToc = document.querySelector('#current-toc');

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5 // Trigger when 50% of the h2 is in the viewport
	};

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				document.querySelectorAll('#table-of-contents li a').forEach(link => {
					link.classList.remove('active');
				});
				const id = entry.target.id;
				const activeLink = document.querySelector(`#table-of-contents li a[href="#${id}"]`);
				if (activeLink) {
					activeLink.classList.add('active');
					currentToc.textContent = activeLink.textContent; // Update the current TOC text
				}
			}
		});
	}, options);

	sections.forEach(section => {
		observer.observe(section);
	});
}



function createSlug(text) {
	// Strip any HTML tags (not usually necessary with textContent)
	text = text.replace(/<\/?[^>]+(>|$)/g, "");

	// Remove footnotes
	text = text.replace(/\[\s*footnote\s.*?\]/gi, "");

	// Convert to lowercase
	text = text.toLowerCase();

	// Non-alpha numeric characters to dashes
	text = text.replace(/[^a-z0-9]+/g, '-');

	// Remove leading and trailing dashes
	text = text.replace(/(^-|-$)/g, '');

	return text;
}